module.exports = __webpack_public_path__ + "img/jhs_common.bced275d.png";